import type { LucideIcon } from "lucide-react";

export function AdminStatCard({
  label,
  value,
  helper,
  icon: Icon,
  tone = "gold"
}: {
  label: string;
  value: string | number;
  helper?: string;
  icon: LucideIcon;
  tone?: "gold" | "green" | "red" | "purple";
}) {
  return (
    <article className={`admin-stat-card ${tone}`}>
      <div>
        <span>{label}</span>
        <strong>{value}</strong>
        {helper ? <small>{helper}</small> : null}
      </div>
      <i><Icon size={22} /></i>
    </article>
  );
}
